/**
 * @deprecated Utiliser `ui/stat.tsx` + `blocks/KPICounter.tsx` à la place.
 * Ce composant est maintenu pour la rétrocompatibilité Puck uniquement.
 */
import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface StatProps {
  value: string;
  label: string;
  source?: string;
}

export function Stat({ value, label, source }: StatProps) {
  return (
    <section className="relative overflow-hidden bg-paper py-20">
      {/* Background subtil */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 dot-grid-masked opacity-60" />
        <div className="spot-glow opacity-70" />
      </div>

      <Container className="relative text-center">
        <div className="mx-auto inline-flex items-center gap-2 rounded-full border border-stone-200 bg-white/80 px-3 py-1 text-[11px] font-medium text-stone-600 shadow-hairline backdrop-blur">
          <span className="live-dot" aria-hidden />
          <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-stone-500">
            Chiffre clé
          </span>
        </div>
        <p className="mx-auto mt-6 font-display text-[clamp(3rem,8vw,5rem)] font-bold leading-none tracking-[-0.035em] text-ink tabular-nums">
          {value}
        </p>
        <p className="mt-4 max-w-xl mx-auto text-[16px] leading-relaxed text-stone-600">{label}</p>
        {source ? (
          <p className="mt-3 font-mono text-[11px] text-stone-400">Source, {source}</p>
        ) : null}
      </Container>
    </section>
  );
}

export const StatConfig: ComponentConfig<StatProps> = {
  fields: {
    value: { type: 'text' },
    label: { type: 'text' },
    source: { type: 'text' },
  },
  defaultProps: { value: '0 €', label: "d'avance trésorerie demandée à l'artisan partenaire", source: 'CGV mandataire CEE' },
  render: Stat,
};
